import React, { Component } from 'react';
import {storyTemplates, checkUploadType,uploadPreview, profilePicValidityCheck} from '../../../utils/constants' 
import { Row, Col, Label, Button, CardTitle, CardText, Input, Modal, ModalBody, ModalHeader} from 'reactstrap';
import Toggle from "react-toggle";
import axios from '../../../axios';
import * as url from '../../../utils/url';
import classnames from 'classnames';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import * as actionCreators from '../../../modules/actions/index';
import ReactPlayer from 'react-player/lazy'
import Checkbox from 'rc-checkbox';
import { takeRightWhile } from 'lodash';


class InviteMembers extends Component {

	constructor(props) {
    super(props);
			this.state = { 
                setImagesPreview:[],
				invitedUsers:[],
				removeUsers:this.props.group.members.map(e=> e.userId),
                searchImg:'',
				bannerImg:null,
				privacy: true,
				isBannerOpen:false
		  }
          this.timer=null
    }

	assignedUserDelay = ({ target })=>{
		const { value } = target;  
		this.setState({ searchedUser: value })
		clearTimeout(this.timer);
		this.timer = setTimeout(() => {
		  this.handleAssignUser(value);
		}, 1000);
	   
	  }
	  

	assignedUserFormat=selectedUser=>{
		let{removeUsers}=this.state

		if(removeUsers.indexOf(selectedUser._id)==-1 || removeUsers.length==0){
		let userId = selectedUser._id
		let organizationId = selectedUser.organizationId 
		let u = {
			// ...selectedUser, 
			email:selectedUser.email,
			profilePic: selectedUser.profilePic,
			firstName:selectedUser.firstName,
			lastName:selectedUser.lastName,
			userId, 
			organizationId, 
			dateJoined: new Date()}

		this.setState(prevState=>({
			invitedUsers: prevState.invitedUsers.concat(u),
			removeUsers: prevState.removeUsers.concat(selectedUser._id), 
			users: [],
			searchedUser:''
		}))
		}
	}
  

	getInitials=(user)=>{
		let firstName = user.firstName &&user.firstName.length>0?user.firstName:'N'
		let lastName = user.lastName &&user.lastName.length>0?user.lastName:'N'
		return firstName.charAt(0).toUpperCase()+ lastName.charAt(0).toUpperCase() 
	  }

	  removeUser = user =>{
		let{invitedUsers}=this.state 
		invitedUsers = invitedUsers.filter(e=> e.userId!=user.userId)
		this.setState({ invitedUsers })
	  }

	  handleAssignUser = value => {
		if(value && value.length>0){
		  let payload = {
			name:value,
			removeUsers: this.state.removeUsers,
			noLoader: true
		  }
		  axios.post(url.searchUsers, payload).then( (resp,idx) =>{
			let users = resp.data.data
			if(users.length==0){
			  users='No users were found'
			}
			this.setState({users})
		  })
		} else {
		  this.setState({users:[]})
		}
	  
	  }
	 

	  inviteUsers=()=>{
		let payload={
			members:this.state.members,
			noLoader:true,
			groupId: this.props.group._id
		}
		let that=this
		axios.post(url.addGroupMembers, payload).then(({ data }) => {
			that.setState({members:data.data})
			// let groupId = data.data._id
			// let url =`/home/groups/${user.profile.organizationId._id}/view/${groupId}`
			// that.props.history.push({pathname : url });
		  }).catch((error) => {
			console.log(error);
		  }) 
	  }

	render() {
		//suggest, showArchived, isSentiment, isAnonymous, topicsSelected, selectedFilter, filters, topics, disableSubmit, stories, collapseCompleted, categoryDefinitionPopoverOpen, archievedStories, showRemoveFeedConfirmationModal,
		let { searchedUser, invitedUsers,users } = this.state;
        console.log('invitedUsers: ', invitedUsers)
  		return (
			<span className="custom_left_menu_section custom_left_section_menu_fields grp_invite_user_container">
				<div className="floating-label-group grp_invite_user_input_item">
				{invitedUsers.length>0?
				<div className="grp_invite_user_input_invited_users_container">
				{ invitedUsers.map((e,idx)=>{
				return (<span key={e.userId+idx} className="grp_invite_user_input_invited_users">
							{profilePicValidityCheck(e.profilePic)?
								<img className="grp_create_search_user_pic" src={e.profilePic}/>
									:
								<span className="spotlightUserInitials" data-letters={this.getInitials(e)}></span>
							}
						{e.firstName} {e.lastName?e.lastName:''}
						<i onClick={()=>this.removeUser(e)}
						className="flaticon-trash"/></span>)
				})}
				</div>
					:
				null}
				<input type="text" id="invitedUsers" className="form-control"
					onChange={this.assignedUserDelay} 
					value={searchedUser}
					autoComplete="off"  placeholder=' '/>
				<label className={invitedUsers.length>0?'floating_label_invite_user':`floating-label`}> Invite members </label>
				{Array.isArray(users) && users.length>0?
				<span className="grp_create_search_user_res">
					<div className="divTable">
					<div className="divTableBody">
						
						{users.map( user => {
							return (
								<div className="divTableRow" onClick={()=>this.assignedUserFormat(user)} key={user._id+user.organizationId}>
								<div className="divTableCell">
									{profilePicValidityCheck(user.profilePic)?
									<img className="grp_create_search_user_pic" src={user.profilePic}/>
									:
									<span className="spotlightUserInitials" data-letters={this.getInitials(user)}></span>
									}
									{user.firstName} {user.lastName}
								</div>
								</div>
							)
							})}
						
														
						</div>
					</div>   
					</span>                   
					:
					null
					}
				</div>

				
					<div className={invitedUsers.length>0?`custom_left_menu_create_button active`:`custom_left_menu_create_button`}
						onClick={invitedUsers.length>0?()=>this.inviteUsers():null} >
							Send Invite(s)
					</div>
		  	</span>
			)
	}
}

const mapStateToProps = state => {
	return {
    user: state.user.profile,
	};
};


const mapDispatchToProps = dispatch => {
	return {
	  storyMetricsChange: (data) => dispatch(actionCreators.storyMetricsChange(data)),
	}
  }


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(InviteMembers));


  
  